<div class="light not-found">
    <div class="context">
        <h1>404</h1>
        <p>Страница не найдена</p>
        <a href="/">Вернуться на главную</a>
    </div>
</div>